import React from 'react';
import Markdown from 'react-markdown/with-html';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import styles from 'styles/jss/original/components/ideas/detailArticle';
import { IIdea } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
};

const DetailArticle: React.FC<ComponentProps> = ({ idea }) => {
  const classes = useStyles();
  const { body } = idea.fields;

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        {/* @ts-expect-error */}
        <GridContainer justify='center'>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={10} md={8}>
            <div className={classes.article}>
              <Markdown source={body} escapeHtml={false} />
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default DetailArticle;
